import apiClient from './client';
import { setSessionId } from '../utils/api';

export async function login(username, password) {
  const res = await apiClient.post('/api/v1/auth/login', { username, password });
  if (res.data.sessionId) setSessionId(res.data.sessionId);
  return res.data;
}

export async function googleLogin(idToken) {
  const res = await apiClient.post('/api/v1/auth/google-login', { idToken });
  if (res.data.sessionId) setSessionId(res.data.sessionId);
  return res.data;
}

export async function logout() {
  return apiClient.post('/api/v1/auth/logout');
}

export async function me() {
  const res = await apiClient.get('/api/v1/auth/me');
  return res.data;
}

export async function validate() {
  const res = await apiClient.get('/api/v1/auth/validate');
  return res.data;
}